import { Box, Typography } from "@mui/material";

const UserInfo = ({label , info}) => {
    return (
        <Box sx={{ display: 'flex', gap: {xs : "0" , sm : "5px"}, py: "5px" }}>
            <Typography sx={{ width: {xs : '60px' , sm : "100px"} , fontWeight: '500' , fontSize:{xs: "13px" , sm : "16px"} }}>{label}</Typography>
            <Typography sx={{ fontWeight: {xs :"400" , sm:"100"} , fontSize:{xs: "13px" , sm : "16px"} }} component={'p'}>{info}</Typography>
        </Box>
    )
}

export default UserInfo;